import { CG3BusinessTypes } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export const getBusinessTypes = async (token: string) => {
  const { data } = await apiInstance(token).get<CG3BusinessTypes>(
    `/backoffice/master-data/business-types`
  );
  return data;
};

const BusinessTypeQueryKey = 'BusinessType';
function getBusinessTypeQueryOptions(token: string) {
  return queryOptions({
    queryKey: [BusinessTypeQueryKey],
    queryFn: () => getBusinessTypes(token),
    select(data) {
      return data.data.filter((it) => it.business_type_desc !== '');
    },
    staleTime: 60_000,
    retry: false,
  });
}

export const useBusinessTypes = (hookOptions?: { enabled?: boolean }) => {
  const token = useAuthStore((s) => s.access_token);

  const base = getBusinessTypeQueryOptions(token);
  const query = useQuery({ ...base, enabled: hookOptions?.enabled ?? true });

  const selectOptions = useMemo(() => {
    return (query.data || []).map((it) => ({
      label: it.business_type_desc,
      value: it.business_type_id,
    }));
  }, [query.data]);

  const maps = useMemo(() => {
    return selectOptions.reduce((p: Record<string, string>, c) => {
      p[c.value] = c.label;
      return p;
    }, {});
  }, [selectOptions]);

  return {
    ...query,
    options: selectOptions,
    maps,
  };
};
